/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Proxy_Printing_DescriptionInputs */



/**
* | output |
* | --- |
* | "Print proxy PDFs from your decks for playtesting, with card images or text placeholders." |
*
* @param {Help_Article_Proxy_Printing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_proxy_printing_description = /** @type {((inputs?: Help_Article_Proxy_Printing_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Proxy_Printing_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Drucke aus deinen Decks Proxy-PDFs zum Testspielen, mit Kartenbildern oder Text-Platzhaltern.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Imprimez des PDF de proxys depuis vos decks pour vos parties de test, avec images de cartes ou substituts textuels.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("从你的卡组打印替代卡 PDF 用于试玩，可选卡图或纯文字版式。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("從你的牌組列印替代牌 PDF 供試玩使用，可選擇卡圖或文字版面。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("테스트 플레이용으로 덱에서 대용 카드 PDF를 만들어 카드 이미지나 텍스트 자리표시자로 인쇄하세요.")
	return /** @type {LocalizedString} */ ("Print proxy PDFs from your decks for playtesting, with card images or text placeholders.")
});